<script lang="ts">
  // We can't use {@html scriptString} since it won't evaluate the javascript script
  // https://github.com/sveltejs/svelte/issues/10900#issuecomment-2016825090
  import { injectScript } from "../lib/helpers/customHTML";

  export let customHtml: string | undefined;
  export let isHeadElement: boolean = false;
  let container: HTMLDivElement;

  $: {
    if (customHtml) {
      console.log("Adding custom HTML ...");
      injectScript({ script: customHtml, element: container, isHeadElement });
    }
  }
</script>
{#if !isHeadElement && customHtml}
  <div bind:this={container} data-testid="custom-html" class="custom-html">
  </div>
{/if}
